import { ApiProperty } from "@nestjs/swagger";

export class CusAddressInfo {
    @ApiProperty()

    addressId: number;
    @ApiProperty()
    addLineOne: string;
    @ApiProperty()
    addLineTwo: string;
    @ApiProperty()
    addLineThree: string;

    @ApiProperty()
    addLineFour: string;

    @ApiProperty()
    addressType: string;
    @ApiProperty()

    createdUser: string;








    /**
    * @param addressId
    * @param addLineOne
    * @param addLineTwo
    * @param addLineThree

    * @param addLineFour

    * @param addressType

    * @param createdUser:
     */
    constructor(addressId: number, addLineOne: string, addLineTwo: string, addLineThree: string, addLineFour: string, addressType: string, createdUser: string) {
        this.addressId = addressId;
        this.addLineOne = addLineOne;
        this.addLineTwo = addLineTwo;
        this.addLineThree = addLineThree;
        this.addLineFour = addLineFour;
        this.addressType = addressType;
        this.createdUser = createdUser;
    }
}


